import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import abo from "../../images/abo_3ntr.jpg";
import MainButton from "./MainButton";

import { ImCancelCircle } from "react-icons/im";
import { Col, Row } from "../../ApiS/Grid-system/Grid-system";
import Input from "../Inputs/Input";
import AddImage from "../../ApiS/AddImage/AddImage";
import { usePOST } from "../../ApiS";
import JoditEditor from "jodit-react";

interface AddProps {
  link?: string;
  check?: boolean;
  enter_result?: any;
  key ?: number | string
}

const Add: React.FC<AddProps> = ({ link, check, enter_result }) => {
  const [popup, setpopup] = useState(false);
  const { handleChangeInput , handleSubmit , setFormData, formData} = usePOST({}, ()=>{},()=>{})

  

  return (
    <>
      <Link to={link || ""}>
        <div
          className={`flex z-10 justify-center  items-center fixed  bottom-10 left-5 font-bold text-5xl bg-Secondary text-white cursor-pointer w-14 h-14 rounded-full`}
          onClick={() => {
            setpopup(!popup);
          }}
        >
          <span className="mb-3">+</span>
        </div>
      </Link>

      {popup  && link==undefined &&(
        <Row className="">
          <Col
            lg={12}
            className="h-[100vh]    w-full flex z-50 justify-center items-center fixed top-0 right-0 font-bold  !bg-black !bg-opacity-50  "
          >
            <Row
              justify={"start"}
              className="relative bg-white w-[80%] h-[70vh] overflow-y-scroll    border-2 border-white rounded-lg"
            >
              <div
                className="absolute cursor-pointer top-5     hover:text-white text-Secondary hover:transition-all flex items-center justify-start   "
                onClick={() => setpopup(!popup)}
              >
                <span className="hover:bg-red-600 bg-gray-100 absolute px-3 py-1 text-2xl flex justify-center items-center rounded-full ">
                  X
                </span>
              </div>

              <Row justify={"center"} className="!mt-8 ">
                

               

                <Col lg={10} sm={10}>
                <h1 className="mb-4 text-2xl text-black font-bold">وصف العنوان باللغة العربية</h1>

                 <JoditEditor value=""  onChange={(e)=>setFormData({...formData , title_ar:e})}/> 
                </Col>
                <Col lg={10} sm={10}>
                <h1 className="mb-4 text-2xl text-black font-bold">وصف العنوان باللغة الانكليزية</h1>

                 <JoditEditor value=""  onChange={(e)=>setFormData({...formData , title_en:e})}/> 
                </Col>
                <Col lg={10} sm={10}>
                <h1 className="mb-4 text-2xl text-black font-bold">وصف الوصف باللغة العربية</h1>

                 <JoditEditor value=""  onChange={(e)=>setFormData({...formData , description_ar:e})}/> 
                </Col>
                <Col lg={10} sm={10}>
                <h1 className="mb-4 text-2xl text-black font-bold">وصف العنوان باللغة الانكليزية</h1>

                 <JoditEditor value=""  onChange={(e)=>setFormData({...formData , description_en:e})}/> 
                </Col>
              

               

             
              </Row>

              <Col className="flex justify-evenly !mt-4 ">
                <Col lg={3} md={5} sm={4}>
                  <MainButton titlebtn="اضافة" className="w-full" onClick={()=>handleSubmit("admin/program-rules")} />
                </Col>

                <Col lg={3} md={5} sm={4}>
                  <MainButton
                    titlebtn="الغاء"
                    className="w-full !bg-gray-200 !text-Secondary"
                    onClick={() => setpopup(!popup)}
                  />
                </Col>
              </Col>
            </Row>
          </Col>
        </Row>
      )}
    </>
  );
};

export default Add;
